import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import DallasButtonSkeleton from '../../../../../../_ui/Dallas/Buttons/DallasButton/DallasButtonSkeleton';

interface Props {
  className: string;
}

export default function ViewPublicLoadSkeletonCell({ className }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasButtonSkeleton size="small" />
    </DallasTableDataCell>
  );
}
